import { ENRICHMENT_ROOT_API_PREFIX } from '@aibees/elephant/constants';
import { HttpMethod } from '@aibees/shared/definition';
import {
  CreateEnrichmentRequest,
  CreateEnrichmentResponse,
} from '@aibees/elephant/types';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';

export function useCreateEnrichmentMutationApi() {
  const workspaceId = useWorkspace()?.id;
  return useBaseMutation<CreateEnrichmentRequest, CreateEnrichmentResponse>({
    url: ENRICHMENT_ROOT_API_PREFIX.replace(':wid', String(workspaceId)),
    method: HttpMethod.post,
  });
}
